import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Cafe } from '../../apiTypes';
import PrimaryButton from '../../components/PrimaryButton';
import { useDocumentOnce } from '../../utils/api';

const CafeCard = ({ id }: { id: string }) => {
  const { data, isValidating } = useDocumentOnce<Cafe>(`cafes/${id}`);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${id}`);
  };

  if (!isValidating && !data?.name) {
    return null;
  }

  return (
    <PrimaryButton
      sx={{
        height: 100,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      variant="outlined"
      fullWidth
      color="inherit"
      onClick={handleClick}
      loading={isValidating}
    >
      {data?.name && <Typography variant="h6">{data.name}</Typography>}
    </PrimaryButton>
  );
};

export default CafeCard;
